import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogDescription,
} from "@/components/ui/dialog";
import { LEGAL_TEXTS } from "@/config/site";

export function LegalModal({ type, trigger, testId }) {
  const content = LEGAL_TEXTS[type];
  return (
    <Dialog>
      <DialogTrigger asChild data-testid={testId}>
        {trigger}
      </DialogTrigger>
      <DialogContent className="max-w-lg border-[#E4E9F2] bg-white">
        <DialogHeader>
          <DialogTitle className="font-heading text-navy">{content.title}</DialogTitle>
          <DialogDescription className="whitespace-pre-line pt-2 text-sm leading-relaxed text-steel">
            {content.body}
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
